import React from 'react';
import Toast from './Toast';
export default (function (_a) {
    var toasts = _a.toasts;
    return React.createElement("div", { className: "toast-container" }, toasts.map(function (toast) { return (React.createElement(Toast, { key: toast.id, toastMessage: toast })); }));
});
